import { Language } from "../i18n/languages";

export const isSwedishOrgNo = (organisationNumber?: string) =>
  organisationNumber?.startsWith("SE") ?? false;

export const isDanishOrgNo = (organisationNumber?: string) =>
  organisationNumber?.startsWith("DK") ?? false;

export const isNorwegianOrgNo = (orgNo: string): boolean => orgNo.match(/^\d{9}$/) !== null;

export const defaultLanguageForOrgNo = (orgNo: string): Language =>
  isSwedishOrgNo(orgNo) ? Language.SV : Language.NO;
